const state = {
  uiState: {
    isLanguageMenuOpened: false,
    isFeedbackMenuOpened: false,
    isMobileMenuOpened: false,
  },
  newsSubscriptionForm: {
    state: 'filling', // 'processing', 'failed', 'success'
    isValid: false,
    errors: [],
    fields: {
      email: '',
    },
  },
  feedbackForm: {
    state: 'filling', // 'processing', 'failed', 'success'
    isValid: true,
    errors: [],
    fields: {
      first_name: '',
      last_name: '',
      phone: '',
      email: '',
      lead_data: {
        comments: '',
      },
    },
  },
};

export default state;
